import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ProgressSpinnerModule } from "@openng/optimus-ui/progressspinner";

@Component({
  standalone: true,
  selector: "app-button",
  imports: [SvgIconComponent, NgClass, TranslateModule, ProgressSpinnerModule],
  templateUrl: "./button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./button.component.scss",
})
export class ButtonComponent {
  public buttonText = input<string | undefined>();
  public buttonIcon = input<string | undefined>();
  public color = input<string>("primary");
  public disabled = input<boolean>(false);
  public block = input<boolean>(false);
  public loading = input<boolean>(false);
}
